export default "__VITE_ASSET__BBs1$HFC__"